import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useConsoleTheme } from '../../lib/theme';

// Light / dark switch for the consoles (docs/light-mode.md §2). Same icons as
// the homepage's switch: Sun while dark (the way to light), Moon while light.
// The label names the action and changes with the theme, so there is no
// aria-pressed (a pressed state plus a changing label reads as a contradiction).
// The utilities below are ordinary dark-console classes; the generated light
// stylesheet remaps them, so the button reads in both themes.
const BASE =
  'inline-flex items-center justify-center shrink-0 w-8 h-8 rounded-full border border-white/[0.08] bg-white/[0.02] ' +
  'text-gray-300 hover:text-white hover:border-white/[0.15] transition-all ' +
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-[#B0FC38]/60';

export default function ThemeToggle({ className = '' }) {
  const { isLight, toggle } = useConsoleTheme();
  const label = isLight ? 'Switch to dark mode' : 'Switch to light mode';
  const Icon = isLight ? Moon : Sun;
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      title={label}
      data-testid="theme-toggle"
      className={className ? `${BASE} ${className}` : BASE}
    >
      <Icon className="w-3.5 h-3.5" aria-hidden="true" data-testid={isLight ? 'theme-icon-moon' : 'theme-icon-sun'} />
    </button>
  );
}
